var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gauge-root"},[_c('Progress',{attrs:{"radius":18,"strokeWidth":10,"strokeColor":"#AFE68B","value":_vm.value},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('Localization',{attrs:{"message":"monthly-summary-forecast-sla"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }